import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ref, getDownloadURL } from "firebase/storage";
import { getStorage } from "firebase/storage";
import { app } from "../../../configs/Firebase";
import Icon from "../../../designSystem/a-atoms/icons/Icon";
import Button from "../../../designSystem/b-molecules/buttons/Button";
import style from "./PersonaCard.module.css";

const PersonaCard = ({ persona, onEdit, onDuplicate, onDelete }) => {
  const navigate = useNavigate();
  const org = useSelector((state) => state.orgStatus.value);
  const [photoURL, setPhotoURL] = useState(null);
  const [showActions, setShowActions] = useState(false);
  const storage = getStorage(app);

  // Load photo from Firebase Storage
  useEffect(() => {
    if (persona.photo && org?.payload && persona.id) {
      const photoPath = `${org.payload}/personas/${persona.id}/${persona.photo}`;
      const storageRef = ref(storage, photoPath);
      getDownloadURL(storageRef)
        .then((url) => setPhotoURL(url))
        .catch(() => {
          // If photo doesn't exist, use placeholder
          setPhotoURL(null);
        });
    } else {
      setPhotoURL(null);
    }
  }, [persona.photo, persona.id, org?.payload, storage]);

  const handleClick = () => {
    navigate(`/personas/${persona.id}`);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    if (onEdit) onEdit(persona);
  };

  const handleDuplicate = (e) => {
    e.stopPropagation();
    if (onDuplicate) onDuplicate(persona);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) onDelete(persona);
  };

  const journeyCount = persona.linkedJourneys?.length || 0;
  const feedbackCount = persona.linkedFeedback?.length || 0;

  return (
    <div 
      className={style.card}
      onClick={handleClick}
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
    >
      <div className={style.photoContainer}>
        {photoURL ? (
          <img src={photoURL} alt={persona.name} className={style.photo} />
        ) : (
          <div className={style.photoPlaceholder}>
            <Icon>person</Icon>
          </div>
        )}
        {showActions && (
          <div className={style.actions}>
            <Button
              variants={["text", "small"]}
              onClick={handleEdit}
              title="Edit"
            >
              <Icon>edit</Icon>
            </Button>
            <Button
              variants={["text", "small"]}
              onClick={handleDuplicate}
              title="Duplicate"
            >
              <Icon>content_copy</Icon>
            </Button>
            <Button
              variants={["text", "small"]}
              onClick={handleDelete}
              title="Delete"
            >
              <Icon>delete</Icon>
            </Button>
          </div>
        )}
      </div>
      <div className={style.content}>
        <h3 className={style.name}>{persona.name}</h3>
        {persona.tagline && (
          <p className={style.tagline}>{persona.tagline}</p>
        )}
        <div className={style.meta}>
          {journeyCount > 0 && (
            <span className={style.metaItem}>
              <Icon>route</Icon> {journeyCount} {journeyCount === 1 ? 'journey' : 'journeys'}
            </span>
          )}
          {feedbackCount > 0 && (
            <span className={style.metaItem}>
              <Icon>feedback</Icon> {feedbackCount} {feedbackCount === 1 ? 'feedback' : 'feedback'}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default PersonaCard;

